<template>
    <div class="dev-page">
        <div class="container">
            <div class="dev-promo">
                <img src="https://admin.sales.bazis.kz/media/logo-bazis-enjoy.svg" alt="">
                <h1>ДАННЫЙ САЙТ НАХОДИТСЯ В РАЗРАБОТКЕ</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'dev--page',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/pages/dev-page.scss';
</style>